// extracted by mini-css-extract-plugin
var _1 = "ra-reviews-logo";
var _2 = "ra-reviews-logo-horizontal";
var _3 = "ra-reviews-logo-icon";
var _4 = "ra-reviews-logo-stars";
var _5 = "ra-reviews-logo-vertical";
export { _1 as "reviewsLogoCls", _2 as "reviewsLogoHorizontalCls", _3 as "reviewsLogoIconCls", _4 as "reviewsLogoStarsCls", _5 as "reviewsLogoVerticalCls" }
